import { useNavigate } from 'react-router-dom';
import customIcons from '../../utils/icons';
import DebtMetricCard from './debtMetricCard';
import LineGraph from '../home/graphLine';
import FallbackGraph from '../home/fallbackGraph';
import tailwindConfig from '../../../tailwind.config';
import { DebtCardInterface } from '../../types/debt.type';

export default function DebtCard({
  displayName,
  description,
  redirectUrl,
  metrics,
  graphData = [],
}: DebtCardInterface) {
  const navigate = useNavigate();
  const tailwindColours = tailwindConfig.theme.extend.colors;

  return (
    <div className="bg-white rounded-lg outline outline-pipgrey-border p-4">
      <div className="flex flex-col h-full">
        {/* Header */}
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            <h3 className="text-lg font-bold text-secondary">{displayName}</h3>
            {description && (<span className="text-primary cursor-help" title={description}>{customIcons.infoIcon}</span>)}
          </div>
          {redirectUrl && (
            <button
              className="button-default button-base text-xs hover:cursor-pointer"
              onClick={() => navigate(`/debt/${redirectUrl}`)}
              type="button"
            >
              <span>{customIcons.eyeSearch}</span>
              <span>More insight</span>
            </button>
          )}
        </div>

        <div id="debt-card-metrics-container" className="flex-1">
          <div id="debt-card-top-row" className="grid grid-cols-3 gap-4">
            {metrics.slice(0, 2).map((metric) => (
              <div
                key={metric.displayName}
                className="bg-white border-r border-pipgrey-border"
              >
                <DebtMetricCard
                  value={metric.value}
                  label={metric.displayName}
                  filters={metric.filters}
                />
              </div>
            ))}
            <div className="relative flex flex-col bg-white max-h-24">
              <div className="px-4 overflow-hidden flex-1 flex flex-col">
                {graphData.length > 1 ? (
                  <>
                    <span className="block w-full text-xs text-piptext-body font-normal text-center">Long term trend</span>
                    <div className="flex-1 min-h-0">
                      <LineGraph
                        graphData={graphData}
                        showAxis={false}
                        gradient
                        colour={tailwindColours.primary.DEFAULT}
                      />
                    </div>
                  </>
                ) : (
                  <FallbackGraph />
                )}
              </div>
            </div>
          </div>

          {metrics.length > 2 && (
            <div id="debt-card-bottom-row" className="grid grid-cols-3 gap-4 mt-4 pt-4 border-t border-pipgrey-border">
              {metrics.slice(2).map((metric, index, array) => (
                <div
                  key={metric.displayName}
                  className={`${index < array.length - 1 ? 'border-r border-pipgrey-border' : ''}`}
                >
                  <DebtMetricCard
                    value={metric.value}
                    label={metric.displayName}
                    filters={metric.filters}
                  />
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
